import type { ComparisonColumn } from "../components/ComparisonTable";

// Edgely column is identical across all comparison tables.
const EDGELY_COLUMN: ComparisonColumn = {
  name: "Edgely",
  highlight: true,
  values: [true, true, true, true, true, true, true, true, true, "Gratuit / 15€"],
};

// competitorKey → its column. Values are factual claims aligned with the prompt.
export const COMPARISON_TABLES: Record<string, ComparisonColumn[]> = {
  tradezella: [
    EDGELY_COLUMN,
    {
      name: "TradeZella",
      values: [false, false, false, true, true, false, true, false, false, "~30$"],
    },
  ],
  tradersync: [
    EDGELY_COLUMN,
    {
      name: "TraderSync",
      values: [false, false, false, true, true, false, false, false, false, "~30$"],
    },
  ],
  notion: [
    EDGELY_COLUMN,
    {
      name: "Notion",
      values: [false, false, true, false, false, false, true, true, false, "Gratuit / 10$"],
    },
  ],
  excel: [
    EDGELY_COLUMN,
    {
      name: "Excel",
      values: [false, false, false, false, false, false, false, true, false, "~7$"],
    },
  ],
  best: [
    EDGELY_COLUMN,
    { name: "TradeZella", values: [false, false, false, true, true, false, true, false, false, "~30$"] },
    { name: "TraderSync", values: [false, false, false, true, true, false, false, false, false, "~30$"] },
    { name: "Notion", values: [false, false, true, false, false, false, true, true, false, "Gratuit / 10$"] },
    { name: "Excel", values: [false, false, false, false, false, false, false, true, false, "~7$"] },
  ],
  alternatives: [
    EDGELY_COLUMN,
    { name: "TradeZella", values: [false, false, false, true, true, false, true, false, false, "~30$"] },
    { name: "TraderSync", values: [false, false, false, true, true, false, false, false, false, "~30$"] },
  ],
};
